import { ordersSaga } from './orders'
import { statusesSaga } from './statuses'
import { outOfficeManagerSaga } from './outOfficeManager'
import { productsSaga } from './products'
import { citySaga } from './city'
import { reserveAccountSaga } from './reserveAccount'
import { sberGeoUnitSaga } from './sberGeoUnit'

export const ordersDesignSaga = [
	ordersSaga(),
	statusesSaga(),
	outOfficeManagerSaga(),
	productsSaga(),
	citySaga(),
	reserveAccountSaga(),
	sberGeoUnitSaga(),
]
